import { createTheme } from '@mui/material/styles';
import "@fontsource/poppins";
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: "#F9FBFF",
      light: "#ffffff",
    },
    blue: {
      main: "#4169E1",
      light: "#D5E0FF",
      lighter: "#EAEFFF",
      dark: "rgb(0, 123, 85)",
      darker: "rgb(0, 171, 85)",
    },
    yellow: {
      main: "#FEA602",
      light: "#E9DA04",

    },
    green: {
      main: "#149700",
      dark: "#009F25"
    },
    secondary: {
      main: '#333333',
      light: "#6E6D6D"
    },
    success: {
      main: "#0D9900"
    },
    error: {
      main: '#FF3B3B',
    },
    background: {
      default: '#fafafa', // Background color for light mode
      paper: '#ffffff', // Background for paper surfaces (like cards)
    },
    text: {
      primary: '#141C36', // Default text color
      secondary: '#ffffff', // Secondary text color

    },
    grey: {
      100: "#A9ACB4"
    }

  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
    h1: {
      fontSize: '36px',
      fontWeight: 500,
      lineHeight: "54px",
      fontFamily: "Poppins"
    },
    h2: {
      fontSize: '30px',
      fontWeight: 500,
      lineHeight: "51px",
      fontFamily: "Poppins"
    },
    h3: {
      // fontSize: '32px',
      fontSize: '22px',
      fontWeight: 500,
      // lineHeight: "48px",
      lineHeight: "30px",
      fontFamily: "Poppins"

    },
    h4: {
      // fontSize: '24px',
      fontSize: '18px',
      fontWeight: 400,
      // lineHeight: "36px",
      lineHeight: "25px",
      fontFamily: "Poppins"
    },
    h5: {
      // fontSize: '20px',
      fontSize: '16px',
      fontWeight: 400,
      // lineHeight: "30px",
      lineHeight: "20px",
      fontFamily: "Poppins"
    },
    h6: {
      // fontSize: '16px',
      fontSize: '12px',
      fontWeight: 400,
      // lineHeight: "24px",
      lineHeight: "20px",
      fontFamily: "Poppins"
    },
    body1: {
      fontSize: '15px',
      fontWeight: 400,
      lineHeight: "22.5px",
      fontFamily: "Poppins"

    },
    body2: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: "21px",
      fontFamily: "Poppins"
    }
  },

  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: "text.primary",
        fontSize: "h6",

      },
    },

    MuiButton: {
      defaultProps: {
        disableElevation: true,
        sx: {
          borderRadius: "5px",
          minHeight: "40px",
          textTransform: "capitalize",
          fontSize: "16px",
          fontWeight: 500,
          lineHeight: "25px",
          padding: "7px 10px",
          




          "&.MuiButton-outlined": {
            color: "blue.main",
            backgroundColor: "transparent",
            border: "1px solid #4169E1"
          },

          "&.MuiButton-contained": {
            color: "text.secondary",
            backgroundColor: "blue.main",
            '&.Mui-disabled': {
              backgroundColor: "#92A8E9",
            },
          },

          // "&.MuiButton-text, &.MuiButton-gost": {
          //   minHeight: "0",
          //   minWidth: "162px",
          //   fontSize: "14px",
          //   fontWeight: 600,
          //   lineHeight: "20px",
          //   borderRadius: "12px",
          //   // padding: "10px",
          // },
          "&.MuiButton-text": {
            color: "#4169E1",
            backgroundColor: "#E9F1FF"

          },

          "&.MuiButton-gost": {
            color: "#fff",
            backgroundColor: "#009A17"
          },

        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 0,
          "&:last-child": {
            paddingBottom: 0,
          },
        },
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          // Hide scrollbar in all browsers
          '&::-webkit-scrollbar': {
            display: 'none', // Chrome, Safari, Edge
          },
          '-ms-overflow-style': 'none', // IE and Edge
          'scrollbar-width': 'none', // Firefox
          overflowY: 'scroll', // keep scrolling functionality
        }
      }
    },

    MuiDataGrid: {
      styleOverrides: {
        root: {
          // — Header row background (top + bottom container)
          "& .MuiDataGrid-container--top [role=row], & .MuiDataGrid-container--bottom [role=row]": {
            backgroundColor: "#4169E1",
          },

          // — Header title styling
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: "16px !important",
            fontWeight: "400 !important",
            color: "#fff",
          },

          // — Resizable column separator invisibility
          "& .MuiDataGrid-columnSeparator--resizable": {
            backgroundColor: "transparent",
          },

          // — Header icons color
          "& .MuiDataGrid-sortIcon, & .MuiDataGrid-filterIcon, & .MuiDataGrid-menuIconButton": {
            color: "#fff",
          },

          // — Borders (cells, footer, etc)
          "& .MuiDataGrid-withBorderColor, & .MuiDataGrid-cell, & .MuiDataGrid-footerContainer": {
            borderColor: "#E4EBFF !important",
          },

          // — Footer container styling
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: "transparent",
            borderTop: "1px solid #E4EBFF",
            padding: "10px",
            justifyContent: "center",
          },

          // // — Center align all cells and their contents
          "& .MuiDataGrid-cell": {
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            textAlign: "center",
            // whiteSpace: "normal",
            // wordWrap: "break-word",
            // overflowWrap: "break-word",
            minHeight: "auto !important",
          },

          // // — Make sure any text/P elements inside cells also center and occupy full width
          "& .MuiDataGrid-cell p, & .MuiDataGrid-cell span": {
            // textAlign: "start",
            // width: "100%",
            // display: "block",
          },

          // — Row height auto (expand to content)
          "& .MuiDataGrid-row": {
            minHeight: "auto !important",
            height: "auto !important",
            display: "flex",
            alignItems: "center",
          },

          // — Ensure virtual scroller content flows naturally
          "& .MuiDataGrid-virtualScrollerContent": {
            minHeight: "auto !important",
          },

          // — Outer grid border
          "& .MuiDataGrid-root": {
            border: "1px solid #E4EBFF !important",
          },
        },
      },
      defaultProps: {
        pageSizeOptions: [10, 25, 50, 100],
        initialState: {
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        },
        checkboxSelection: false,
      },
    },

  },
});


export default theme;
